import { BookingAction } from './booking-action';
import { BookingParams, BookingPosition, BookingResult } from '../types';

/**
 * Geteilter Kern aller Buchungen mit Quelle = KFZ. Hält die welt-uniforme
 * Richtung KFZ → KFZ (Umlagerung). Welt-eigene Richtungen leben in der
 * jeweiligen Subklasse.
 */
export abstract class FromCarActionBase extends BookingAction {
  /**
   * KFZ → KFZ: Umlagerung zwischen zwei Fahrzeugen. Legt das
   * CarRelocationMovement online an (Phase 1, `createRemote`, ohne Queue) und
   * spiegelt -amount auf das eingeloggte (abgebende) KFZ. Phase 2
   * (Empfangsbestätigung) läuft am Ziel-KFZ. Kein Transaction-Enqueue, weil die
   * Umlagerung kein Auftrags-/Fill-Vorgang ist.
   *
   * @param position Zu buchende Position (article_id und amount)
   * @param params Buchungskontext, Adapter und stabile client_ids
   * @returns BookingResult; Fehler bei fehlender targetId, amount <= 0 oder fehlgeschlagenem Remote-Anlegen
   */
  protected async toCar(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    const { context, adapters } = params;
    const { booking } = context;

    if (booking.targetId === undefined) {
      return this.failure('KFZ->KFZ: targetId (Ziel-KFZ) fehlt');
    }
    if (position.amount <= 0) {
      return this.failure('KFZ->KFZ: amount muss > 0 sein');
    }

    // Remote zuerst (online-only, kein Queueing). Schlägt es fehl, bleibt das
    // Fahrzeug unangetastet. Idempotent via client_id.
    const movement = adapters.movement.build(
      position,
      booking,
      params.clientIds.idFor(position),
    );
    const created = await adapters.movement.createRemote(movement);
    if (!created.value) {
      return this.failure(
        'CarRelocationMovement konnte nicht angelegt werden',
        created.retryable,
      );
    }

    // Optimistischer -amount-Spiegel auf dem lokalen CAR_STORAGE (Quelle =
    // eingeloggtes KFZ). Spiegel-Fehler bleibt success (Buchung steht; der
    // Inventar-Pull der Seite gleicht ab).
    await adapters.car.updatePositionAmountLocal(position, -position.amount);
    return this.success();
  }
}
